<template>
    <section class="flex flex-col flex-1">
        <div class="flex-1 container mx-auto text-sm">
            <div class="w-full max-w-5xl mx-auto">
                <div class="flex flex-col lg:flex-row lg:items-center">
                    <div class="mt-4 lg:mt-0">
                        <router-link
                            to="/"
                            class="
                                px-6 py-2
                                inline-flex
                                items-center
                                justify-center
                                font-medium
                                hover:opacity-75
                                group-hover:opacity-75
                                shadow-sm
                                focus:outline-none
                                focus:ring
                                focus:ring-blue
                                focus:ring-opacity-25
                                transition
                                ease-in-out
                                duration-300
                                disabled:opacity-50
                                disabled:cursor-not-allowed
                                bg-blue border border-transparent text-white
                                rounded-full
                            "
                        >
                            <chevron-left-icon class="h-5 w-5 mr-2" />
                            New Search
                        </router-link>
                    </div>
                </div>
                <div class="building-info-component">
                    <card-container spacing="lg" class="w-full mt-4 overflow-hidden">
                        <div class="mb-5">
                            <div class="border-b border-blue-900 px-3 py-2">
                                <h2 class="font-bold">Building Info</h2>
                            </div>
                            <div class="flex flex-row mt-3 px-3">
                                <div class="flex-1">
                                    <div class="mb-2">
                                        <p><strong>Building ID:</strong> {{ details?.building_details.custom_building_id }}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p><strong>Building Name:</strong> {{ details?.building_details.building_name | title_case_format }}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p><strong>Street Address:</strong> {{ details?.address.street | title_case_format }}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p><strong>Building Size (reported building GFA):</strong> {{ details?.building_details.gfa_reported | number_format }}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p><strong>Benchmarking Group:</strong> {{ details?.benchmarking_group | title_case_format }}</p>
                                    </div>
                                </div>
                                <div class="flex-1">
                                    <div class="mb-2">
                                        <p><strong>Largest Property Uses:</strong></p>
                                    </div>
                                    <div class="mb-2">
                                        <p>
                                            <strong><span class="w-6 inline-block">1<sup>st</sup></span>:</strong>
                                            <span class="capitalize" v-if="details?.building_details.largest_property_use_type && details?.building_details.largest_property_use_type != 0">
                                                {{ details?.building_details.largest_property_use_type }}
                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <p>
                                            <strong><span class="w-6 inline-block">2<sup>nd</sup></span>:</strong>
                                            <span class="capitalize" v-if="details?.building_details.second_largest_property_use_type && details?.building_details.second_largest_property_use_type != 0">
                                                {{ details?.building_details.second_largest_property_use_type  }}
                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </p>
                                    </div>
                                    <div class="mb-2">
                                        <p>
                                            <strong><span class="w-6 inline-block">3<sup>rd</sup></span>:</strong>
                                            <span class="capitalize" v-if="details?.building_details.third_largest_property_use_type && details?.building_details.third_largest_property_use_type != 0">
                                                {{ details?.building_details.third_largest_property_use_type  }}
                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="details" class="mb-5">
                            <benchmarking-table
                                :building="details?.building_details"
                                :submissions="details?.submissions"
                                :flags="details?.alerts"
                                :beps="details?.beps"
                            />
                        </div>
                        <div v-if="details"  class="mb-5">
                            <baseline-table
                                :building="details?.building_details"
                                :submissions="details?.submissions"
                                :beps="details?.beps"
                            />
                        </div>
                        <div class="mb-5">
                            <performance
                                :submissions="details?.submissions"
                                :beps="details?.beps"
                            />
                        </div>
                    </card-container>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import BenchmarkingTable from '@/components/building-details/BenchmarkingPartial.vue';
import BaselineTable from '@/components/building-details/BaselinePartial.vue';
import Performance from '@/components/building-details/PerformancePartial.vue';
import ApiService from '@/services/apiService';
import { ChevronLeftIcon } from '@touchstone/touchstone-assets';

export default {

    components: {
        ChevronLeftIcon,
        BenchmarkingTable,
        BaselineTable,
        Performance
    },

    data() {
        const srv = new ApiService();
        return {
            api: srv.searchApi(),
            details: null,
            submissions: []
        };
    },

    created() {
        this.searchById();
    },

    methods: {
        async searchById() {
            try {
                const id = this.$route.params.id;
                const { data } = await this.api.searchBPSLookup(id);
                this.submissions = data.building_details.submissions;
                this.details = data;
            } catch (e) {
                console.log('e', e);
                // this.setError(e);
            }
            this.loading = false;
        }
    }

};

</script>
